module.exports = __webpack_public_path__ + "img/itchio-textless-black.5f69756f.svg";